import OverUnder from "../pages/LiveVariant/components/OverUnder";
import Flip from "../pages/LiveVariant/components/Flip";
import Puzzle from "../pages/LiveVariant/components/Puzzle";
import UserProfile from "../pages/LiveVariant/components/Social/UserProfile";
import ListingFeed from "../pages/LiveVariant/components/Social/ListingFeed";
import ListingPage from "../pages/LiveVariant/components/Social/ListingPage";
import HouseSoldIcon from "../assets/icons-v2/house-sold-icon.png";

import OverUnderIcon from "../assets/icons-v2/over-under.png";
import FlipIcon from "../assets/icons-v2/flip.png";
import HiddenInfoIcon from "../assets/icons-v2/hidden-info.png";
import PuzzleIcon from "../assets/icons-v2/Puzzle-logo.png";
import SocialIcon from "../assets/icons-v2/social_icon_fallback.png";

import OverUnderModalBody from "../components/modals/LiveVariant/HelpModal/components/OverUnderModalBody";
import FlipModalBody from "../components/modals/LiveVariant/HelpModal/components/FlipModalBody";
import PuzzleModalBody from "../components/modals/LiveVariant/HelpModal/components/PuzzleModalBody";

export const LIVE_VARIANT_VERSIONS = {
    social: {
        url: "social",
        label: "social",
        component: <ListingFeed />,
        userProfile: <UserProfile />,
        listingPage: <ListingPage />,
        title: "PriceMe Social",
        description:
            "See the homes everyone’s talking about. Leave comments, share listings, and follow your favorite neighborhoods.",
        disabled: process.env.REACT_APP_STAGE === "production",
        icon: {
            src: SocialIcon,
            width: 90,
            height: 90,
        },
        hideInProfile: true,
        disableInProfile: true,
        hideTag: true,
    },
    v5: {
        url: "puzzle",
        label: "puzzle",
        component: <Puzzle version="v5" />,
        gaVersion: "V5 - Puzzle",
        title: "PriceMe Puzzle",
        description: "Get 6 chances to guess the price - each guess reveals hints about the actual price",
        icon: {
            src: PuzzleIcon,
            width: 70,
            height: 70,
        },
        modal: {
            body: <PuzzleModalBody />,
            show_actual_price: true,
            hide_solved: true,
        },
        max_tries: 6,
        score_by: "tries",
    },
    classic: {
        url: "classic",
        label: "classic",
        component: <Puzzle version="v5" />,
        gaVersion: "",
        title: "PriceMe Classic",
        description:
            "Guess the price of 3 homes that just sold near you. The closer your guess, the more points you get",
        icon: {
            src: HouseSoldIcon,
            width: 90,
            height: 59,
        },
    },
    v1: {
        url: "over-under",
        label: "over-under",
        component: <OverUnder version="v1" />,
        gaVersion: "V1 - Over/Under",
        title: "PriceMe Over/Under",
        description: "Guess if the actual price is higher or lower than the guess price",
        icon: {
            src: OverUnderIcon,
            width: 70,
            height: 70,
        },
        modal: {
            body: <OverUnderModalBody />,
            show_actual_price: true,
        },
        variance: {
            start: 0.6,
            end: 0.7,
        },
        max_tries: 3,
        disabled: true,
        disableInProfile: true,
    },
    v3: {
        url: "flip",
        label: "flip",
        component: <Flip version="v3" />,
        title: "PriceMe Flip",
        description: "Compare two properties and guess which one sold for more",
        icon: {
            src: FlipIcon,
            width: 65,
            height: 65,
        },
        modal: {
            body: <FlipModalBody />,
            show_actual_price: true,
        },
        max_tries: 3,
        disabled: true,
        disableInProfile: true,
    },
    v4: {
        url: "hidden-info",
        label: "hidden",
        component: null,
        title: "PriceMe Hidden Info - Coming soon!",
        description:
            "Get 7 chances to guess within 5% of a the sold price - without going over. Reveal more info after each guess.",
        disabled: true,
        icon: {
            src: HiddenInfoIcon,
            width: 70,
            height: 70,
        },
        hideInProfile: true,
        disableInProfile: true,
    },
};
